import { motion } from "framer-motion";

const PHOTOS = [
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_market-gateway-8/artifacts/kghzqd5h_1654840953680%20%281%29.jpeg",
    tag: "Trade Delegation",
    caption: "India–Qatar Business Forum — Doha",
    wide: true,
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_market-gateway-8/artifacts/hsnimxl0_1663909642017%20%281%29.webp",
    tag: "Policy Dialogue",
    caption: "ASSOCHAM Roundtable with the British High Commissioner — New Delhi",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_market-gateway-8/artifacts/cn9mp7bz_WhatsApp%20Image%202026-09-29%20at%2018.23.10%20%281%29.webp",
    tag: "Global Partnerships",
    caption: "Bilateral business engagement with international delegates",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_market-gateway-8/artifacts/r54qas7y_WhatsApp%20Image%202026-09-29%20at%2018.23.10.jpeg",
    tag: "Networking",
    caption: "With international trade delegates",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_market-gateway-8/artifacts/vr5vbz44_1785143597913.webp",
    tag: "Leadership",
    caption: "Global business summit address",
  },
];

export const Gallery = () => (
  <section id="gallery" data-testid="gallery-section" className="relative bg-royal py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="flex flex-col justify-between gap-6 md:flex-row md:items-end"
      >
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-gold sm:text-xs">Gallery</p>
          <h2 className="mt-6 max-w-xl font-serif text-3xl font-medium leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
            Moments from the global stage.
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-slate-400">
          Glimpses of delegations, roundtables, and partnerships that shape cross-border opportunity.
        </p>
      </motion.div>

      <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {PHOTOS.map(({ src, tag, caption, wide }, i) => (
          <motion.figure
            key={src}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: (i % 3) * 0.1, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`gallery-photo-${i + 1}`}
            className={`group relative overflow-hidden rounded-xl border border-white/10 transition-colors duration-500 hover:border-gold/50 ${
              wide ? "sm:col-span-2" : ""
            }`}
          >
            <img
              src={src}
              alt={caption}
              loading="lazy"
              className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${
                wide ? "aspect-[2/1]" : "aspect-[4/3]"
              }`}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-royal-deep/90 via-transparent to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-100" />
            <figcaption className="absolute bottom-0 left-0 w-full p-5">
              <p className="font-mono text-[9px] uppercase tracking-[0.28em] text-gold">{tag}</p>
              <p className="mt-1.5 font-serif text-base font-semibold text-white sm:text-lg">{caption}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
